var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperclip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    title: "Attach icon",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9375 10.1875L7.81246 2.06252C6.20852 0.57508 3.71555 0.622037 2.16876 2.16883C0.621976 3.71561 0.575019 6.20858 2.06246 7.81252L3.93746 9.68752L4.81871 8.80627L2.94371 6.93127C2.19126 6.23013 1.88153 5.17419 2.13602 4.17769C2.3905 3.18119 3.16863 2.40307 4.16513 2.14858C5.16163 1.89409 6.21757 2.20382 6.91871 2.95627L15.0437 11.0813C15.7962 11.7824 16.1059 12.8384 15.8514 13.8349C15.5969 14.8314 14.8188 15.6095 13.8223 15.864C12.8258 16.1185 11.7699 15.8087 11.0687 15.0563L7.23746 11.225C6.84 10.8298 6.68359 10.2526 6.82713 9.71073C6.97068 9.16891 7.39238 8.74483 7.93338 8.59823C8.47439 8.45164 9.0525 8.6048 9.44996 9.00002L11.4312 10.9813L12.3125 10.1C12.3125 10.1 10.3 8.08127 10.2812 8.07502C9.17386 7.05237 7.45642 7.08718 6.39142 8.15386C5.32641 9.22054 5.29431 10.938 6.31871 12.0438L10.1875 15.9375C11.7914 17.425 14.2844 17.378 15.8312 15.8312C17.3779 14.2844 17.4249 11.7915 15.9375 10.1875Z",
    fill: "#0A5A67"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.6cea6362.svg";
export { ForwardRef as ReactComponent };